import React, { useEffect, useState, } from "react"
import { useDispatch, useSelector, } from "react-redux"
import joystickLogo from "../../assets/images/joystick-logo.png"
import { authorise, } from "../../redux/actions/authActions"
import { dashboardURL, } from "../../constants"
import LoginModalComponent from "../pages/auth/LoginModalComponent"

import $ from'jquery/dist/jquery.min.js'

import "./Header.scss"

export default function Header(props) {
  const [loading, setLoading] = useState(true)
  const authResponse = useSelector(state=>state.auth)
  const dispatch = useDispatch()

  useEffect(() => {
    // navbarScrollEffect()
    dispatch(authorise())
    setLoading(false)    
  }, [])

  // const navbarScrollEffect = () => {
  //   if (959 < window.innerWidth) {
  //     $('.header-container').removeClass('past-main');
  //     // The built-in template scroll effect doesn't work
  //     // so we've reimplemented it here using jQuery
  //     // Source: https://stackoverflow.com/questions/20276166/how-do-i-make-my-navbar-change-css-class-upon-scrolling-past-an-anchor-point
  //     var mainbottom = $('#top').offset().top + $('#top').height();
  //     // on scroll, 
  //     $(window).on('scroll',function(){
  //       // we round here to reduce a little workload
  //       stop = Math.round($(window).scrollTop());
  //       if (stop > mainbottom) {
  //           $('.header-container').addClass('past-main');
  //       } else {
  //           $('.header-container').removeClass('past-main');
  //       }
  //     });
  //   } else {
  //     // Set timeout to let DOM render - otherwise .header-container does not exist yet.
  //     setTimeout(() => {
  //       $('.header-container').addClass('past-main').addClass("test");
  //     }, 500);
  //   }
  // }

  const [modalIsOpen, setIsOpen] = useState(false)

  function openModal() {
    setIsOpen(true)
  }

  function closeModal() {
    setIsOpen(false)
  }

  const renderNavLinks = () => {
    if(authResponse.data) {
      return <>
        <li className="nav-item dropdown auth-navbar-dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            User
          </a>
          <ul className="dropdown-menu">
            <li>
              <a
                className="dropdown-item"
                href="/user/payment-methods"
              >
                Payment Methods
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                href="/user/settings"
              >
                Settings
              </a>
            </li>
            <li>
              <a
                className="dropdown-item"
                href="/user/logout"
              >
                Logout
              </a>
            </li>
          </ul>
        </li>
      </>
    } else {
      return <>
        <a href="/user/register" className="btn btn-primary joystick-success">Sign Up</a>
        <ul className="navbar-nav">
          <li className="nav-item"><a style={{ cursor: "pointer" }} className="nav-link px-3" onClick={openModal}>Log In</a></li>
          <LoginModalComponent
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
          />
        </ul>
      </>
    }
  }

  if (loading) {
    return null
  }

  return <nav
    className="navbar navbar-expand-lg navbar-light fixed-top py-3 header-container past-main"
    // data-navbar-on-scroll="light"
  >
    <div className="container">
      <a className="navbar-brand" href="/">
        <img
          src={joystickLogo}
          height="75"
          alt="logo"
        />
      </a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
      <div className="collapse navbar-collapse border-top border-lg-0 mt-4 mt-lg-0" id="navbarSupportedContent">
        <ul className="navbar-nav ms-auto pt-2 pt-lg-0 font-base align-items-center">
          <li className="nav-item"><a className="nav-link px-3" href="/">Home</a></li>
          <li className="nav-item"><a className="nav-link px-3" href="/games">Games</a></li>
          <li className="nav-item"><a className="nav-link px-3" href="/about">About</a></li>
          <li className="nav-item"><a className="nav-link px-3" href={dashboardURL}>Dashboard</a></li>
        </ul>
        {renderNavLinks()}
      </div>
    </div>
  </nav>
}
